import { Viewport } from '@radix-ui/react-toast';

import * as styles from './toastViewport.css';

export const ToastViewport: React.FC = () => <Viewport className={styles.viewport} />;
